
import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgSelectComponent } from '@ng-select/ng-select'
import { NgbModal, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { UserService } from '@services/core/user.service';
import { PanelComponent } from '@components/core-template/panel/panel.component';
import { RequestInsuredService } from '@services/requestInsured.service';

@Component({
  selector: 'app-type-movimientos',
  templateUrl: './movimientos.component.html',
  styleUrls: ["./movimientos.component.css"],
  imports: [PanelComponent, FormsModule, ReactiveFormsModule],
  providers: [UserService, RequestInsuredService],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypeMovementsComponent implements OnInit {

  private _userService = inject(UserService)
  private _requestService = inject(RequestInsuredService)
  private _fb = inject(FormBuilder)
  private _modalService = inject(NgbModal)
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)
  protected types: any
  protected search = ""

  private modalOptions = {
    size: 'xl',
    scrollable: true,
    animation: true,
    backdrop: true
  }
  public closeResult = ""
  protected newTypeForm = this._fb.group({
    _id: [null],
    name: ["", Validators.required],
    enabled: [true],
  })

  ngOnInit(): void {
    this.getTypeMovements();
  }

  open(modal: any, type?: any) {
    this.newTypeForm.reset();
    this.newTypeForm.patchValue({ enabled: true })
    if (type) this.newTypeForm.patchValue(type)
    this._modalService.open(modal, this.modalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `${reason}`;
    });
  }

  getTypeMovements() {
    this._requestService.getTypeMovement().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.types = res
      this.cdr.markForCheck()
    })
  }

  saveType() {
    if (this.newTypeForm.value._id) { 
      this._requestService.updateTypeMovement(this.newTypeForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response) => { });
    } else {
      this._requestService.createTypeMovement(this.newTypeForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response) => { })
    }
    this.getTypeMovements()
  }

  enabledRole(type: any) {
    type.enabled = !type.enabled
    this._requestService.updateTypeMovement(type).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response) => {
      this.types = response
      this.cdr.markForCheck()
    });
  }

} 
